<template>
  <v-container
    class="pt-12 pt-sm-0"
    fill-height
  >
    <v-layout
      align-content-center
      justify-center
      wrap
    >
      <v-flex
        v-for="(theme, i) in themes"
        :key="i"
        xs12
        md6
        py-5
      >
        <v-hover>
          <v-card
            slot-scope="{ hover }"
            flat
            color="transparent"
            class="d-block mx-auto"
            :href="theme.href"
            target="_blank"
            max-width="450"
            rel="noopener"
            :title="`Material Kit - ${theme.name} Theme`"
          >
            <div
              class="headline mb-3 text-uppercase"
              v-text="theme.name"
            />
            <v-img
              :aspect-ratio="16/9"
              :src="require(`@/assets/${theme.img}.png`)"
              height="225"
              :class="`elevation-${hover ? 24 : 4}`"
              class="transition-swing"
            >
              <v-fade-transition>
                <v-sheet
                  v-if="hover"
                  color="primary"
                  style="opacity: .12"
                  height="100%"
                  width="100%"
                />
              </v-fade-transition>
            </v-img>
            <div
              class="mt-3"
              v-text="theme.desc"
            />
          </v-card>
        </v-hover>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    metaInfo () {
      return {
        title: this.$i18n.t('Home.title')
      }
    },

    data: () => ({
      themes: [
        {
          name: 'Launcher',
          desc: 'A creative launching platform for games, media and applications.',
          img: 'launcher',
          href: 'https://material-launcher.vuetifyjs.com'
        },
        {
          name: 'Portfolio Dark',
          desc: 'Built on top of the JSON Resume specification, this theme allows you to plug-in your own information and have a site ready to go in minutes.',
          img: 'portfolio-dark',
          href: 'https://material-portfolio-dark.vuetifyjs.com'
        },
        {
          name: 'Landing',
          desc: 'A simple and clean landing page / blog static site with bold hero images and sharp material accents.',
          img: 'landing',
          href: 'https://material-landing.vuetifyjs.com'
        },
        {
          name: 'Activity Dashboard',
          desc: 'An activity dashboard made to display status information for your business.',
          img: 'activity-dashboard',
          href: 'https://material-activity-dashboard.vuetifyjs.com'
        },
        {
          name: 'Crypto Service',
          desc: 'A two page service theme designed to highlight an application.',
          img: 'crypto',
          href: 'https://material-crypto.vuetifyjs.com'
        }
      ]
    })
  }
</script>
